import React, { useState } from "react";
import {
  Container,
  ImageContainer,
  Header,
  DownloadIcon,
  Body,
  Wrapper,
  Item,
  List,
  Field,
  Title,
  Flags,
  Flag,
  Lead,
} from "./style";

import download from "src/assets/download.svg";
import copyIcon from "src/assets/copy.svg";
import CheckMark from "src/assets/CheckMark.svg";

import { accounts } from "./accounts";
import { Icon } from "src/components";
import { theme } from "src/theme/theme";

export const Details = ({ client }) => {
  const [selectedAccount, setSelectedAccount] = useState(accounts[0]);
  const [coppied, setCoppied] = useState([]);

  const setFlag = (id) => {
    const ac = accounts.find((a) => a.id === id);
    if (ac) {
      setSelectedAccount(ac);
      setCoppied([]);
    }
  };

  return (
    <Container>
      <Wrapper>
        <Header>
          <span style={{ color: theme.colors.primary["500"] }}>
            {process.env.REACT_APP_BANK_NAME || ""} Account
          </span>
          <ImageContainer
            title="Download as PDF"
            target="_blank"
            href="https://storage.googleapis.com/finamaze-integration/FinaMaze%20Account%20Details%20for%20Client%20Deposits%20(1).pdf"
          >
            <DownloadIcon alt="download" src={download} />
          </ImageContainer>
        </Header>
        <Body>
          {/* <Title>Remittance Country</Title>
          <Flags>
            {accounts?.map((ac) => (
              <Flag
                onClick={() => setFlag(ac.id)}
                active={selectedAccount?.id === ac.id}
                key={ac.id}
                disabled={ac.disable}
              >
                {ac.Icon} {ac.name}
              </Flag>
            ))}
          </Flags> */}
          <List>
            {selectedAccount?.values
              ?.filter(
                (obj) => obj.label !== "IBAN" && obj.label !== "Account Number",
              )
              .map((account, i) => (
                <Item key={i}>
                  <Title>{account.label}</Title>
                  <Field
                    coppied={
                      coppied.find((c) => c === i + 1) ? "copied" : undefined
                    }
                    /**
                     * `text` — so the button copies the VALUE.
                     *
                     * antd copies a Paragraph's rendered children when no
                     * text is given, and the children here were
                     * `value.substring(0, 24) + "..."`. So pressing copy on
                     * the beneficiary name put "FinaMaze Limited - Clien..."
                     * on the clipboard, and that is what went into the wire
                     * form at the customer's bank.
                     */
                    copyable={{
                      text: account.value,
                      icon: [
                        <Icon
                          style={{ width: "20px" }}
                          color="blue"
                          src={copyIcon}
                          key="blue"
                        />,
                        <Icon
                          style={{ width: "20px" }}
                          color="green"
                          src={CheckMark}
                          key="green"
                        />,
                      ],
                      onCopy: () => {
                        setCoppied((oldcopy) => [...oldcopy, i + 1]);
                      },
                      tooltips: ["Copy", "Copied"],
                    }}
                  >
                    {/* In full, and wrapping. A detail that has to be
                        transcribed into a bank's form has to be readable
                        first — see Field. */}
                    {account.value}
                  </Field>
                </Item>
              ))}
            {/* It was a second 1.5em bold accent HEADLINE in the middle of
                the pane, wrapping to two lines — the same size and colour as
                the pane's own name, so the panel appeared to start again. It
                is the sentence it always was. */}
            <Lead>Wire your funds to the account for the currency you are sending.</Lead>
            <Title>Remittance currency</Title>
            <Flags>
              {accounts?.map((ac) => (
                <Flag
                  onClick={() => setFlag(ac.id)}
                  active={selectedAccount?.id === ac.id}
                  key={ac.id}
                  disabled={ac.disable}
                >
                  {ac.Icon} {ac.name}
                </Flag>
              ))}
            </Flags>
            <Item>
              <Title>IBAN</Title>
              <Field
                coppied={
                  coppied.find((c) => c === "account") ? "copied" : undefined
                }
                copyable={{
                  text: selectedAccount?.values.find(
                    (obj) => obj.label === "IBAN",
                  )?.value,
                  icon: [
                    <Icon
                      style={{ width: "20px" }}
                      color="blue"
                      src={copyIcon}
                      key="blue"
                    />,
                    <Icon
                      style={{ width: "20px" }}
                      color="green"
                      src={CheckMark}
                      key="green"
                    />,
                  ],
                  tooltips: ["Copy", "Copied"],
                }}
              >
                {/* `.filter(...)[0].value` threw the moment a currency
                    had no row with this label. */}
                {
                  selectedAccount?.values.find((obj) => obj.label === "IBAN")
                    ?.value
                }
              </Field>
            </Item>
            <Item>
              <Title>Account Number</Title>
              <Field
                coppied={
                  coppied.find((c) => c === "account") ? "copied" : undefined
                }
                copyable={{
                  text: selectedAccount?.values.find(
                    (obj) => obj.label === "Account Number",
                  )?.value,
                  icon: [
                    <Icon
                      style={{ width: "20px" }}
                      color="blue"
                      src={copyIcon}
                      key="blue"
                    />,
                    <Icon
                      style={{ width: "20px" }}
                      color="green"
                      src={CheckMark}
                      key="green"
                    />,
                  ],
                  tooltips: ["Copy", "Copied"],
                }}
              >
                {
                  selectedAccount?.values.find(
                    (obj) => obj.label === "Account Number",
                  )?.value
                }
              </Field>
            </Item>
          </List>
        </Body>
      </Wrapper>
    </Container>
  );
};
